// @ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import {
  fmtDateTime,
  interviewStartSlotStatus,
  formatInterviewCountdown,
  INTERVIEW_SLOT_CLOSED_MESSAGE,
} from "@/legacy/helpersModule";
import { InterviewScheduleModal } from "@/features/hr/components/InterviewScheduleModal";
import { PreInterviewCheck } from "@/features/interview/components/PreInterviewCheck";
import { Button, Field, Select } from "@/shared/components/ui";
import { useEscapeKey } from "@/shared/hooks/useEscapeKey";
export function Intro({ candidate, job, onStart, onBack, onLogout, onSchedule, interviewScheduledAt, bypassSchedule, eligibilityBlock }) {
  useEscapeKey(onBack);
  const [lang, setLang] = useState("English");
  const [micReady, setMicReady] = useState(false);
  const stopLobbyMicRef = useRef(() => {});
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);
  const [showSched, setShowSched] = useState(false);
  const [schedBusy, setSchedBusy] = useState(false);
  const [clockTick, setClockTick] = useState(0);
  useEffect(() => {
    if (bypassSchedule || !interviewScheduledAt) return undefined;
    const id = setInterval(() => setClockTick((x) => x + 1), 1000);
    return () => clearInterval(id);
  }, [bypassSchedule, interviewScheduledAt]);
  void clockTick;
  const slot = interviewStartSlotStatus(interviewScheduledAt, bypassSchedule);
  const blockSchedule = Boolean(slot.blocked);
  const blockInterview = Boolean(eligibilityBlock);
  const startDisabled = blockSchedule || blockInterview;
  const countdown =
    slot.hasSlot && slot.tooEarly && interviewScheduledAt
      ? formatInterviewCountdown(interviewScheduledAt)
      : null;
  const startLabel = countdown ? `Starts in ${countdown}` : "🎤 Start →";
  const handleScheduleConfirm = async (iso) => {
    setSchedBusy(true);
    try {
      await onSchedule(iso);
      setShowSched(false);
    } finally {
      setSchedBusy(false);
    }
  };
  return (
    <div className="min-h-dvh bg-white flex items-center justify-center p-4 safe-bottom">
      <img
        src="/great-place-to-work.png"
        alt="Indira IVF — Great Place To Work Certified, Jan 2026–Jan 2027, India"
        className="hidden sm:block fixed fixed-safe-top-right w-16 md:w-20 h-auto z-10 drop-shadow-lg"
        loading="lazy"
      />
      <div className="w-full max-w-2xl bg-white border border-line rounded-2xl p-4 sm:p-8 text-center shadow-sm">
        <div className="w-16 h-16 bg-brand-600 rounded-2xl mx-auto flex items-center justify-center mb-4 text-3xl">🎤</div>
        <h1 className="text-lg sm:text-2xl font-black text-ink-900 mb-1">Voice Interview</h1>
        <p className="text-ink-400 text-sm mb-1">Hello, <span className="text-ink-900 font-bold">{candidate?.name}</span></p>
        <p className="text-brand-600 font-semibold mb-4">{job?.title}</p>
        {interviewScheduledAt ? (
          <p className="text-xs text-teal-700 mb-3">📅 Scheduled: {fmtDateTime(interviewScheduledAt)}</p>
        ) : null}
        <div className="bg-brand-50 border border-brand-200 rounded-xl p-3 mb-5 text-left text-xs text-ink-600"><p className="font-bold text-brand-700 mb-1">🎙️ How it works</p><p>Allow and test your microphone below, then press Start. AIRA asks each question aloud; your reply is captured automatically after a short pause.</p></div>
        <div className="mb-5 text-left">
          <Field label="Language">
            <Select value={lang} onChange={e => setLang(e.target.value)}>{["English", "Hindi", "Bengali", "Tamil", "Telugu", "Kannada", "Marathi", "Gujarati", "Malayalam"].map(l => <option key={l} value={l}>{l}</option>)}</Select>
          </Field>
        </div>
        {eligibilityBlock ? <p className="text-amber-800 text-xs mb-3 text-left bg-amber-50 border border-amber-200 rounded-lg p-3">{eligibilityBlock}</p> : null}
        {slot.hasSlot && slot.tooEarly ? <p className="text-amber-700 text-xs mb-3 text-left">Start unlocks at {fmtDateTime(interviewScheduledAt)} (your time).</p> : null}
        {slot.hasSlot && slot.tooLate ? <p className="text-amber-800 text-xs mb-3 text-left bg-amber-50 border border-amber-200 rounded-lg p-3">{INTERVIEW_SLOT_CLOSED_MESSAGE}</p> : null}
        {!blockInterview && !(slot.hasSlot && slot.tooLate) ? (
          <div className="mb-4">
            <PreInterviewCheck
              busy={false}
              showStartButton={false}
              onReadyChange={setMicReady}
              onStopMonitoringReady={(stop) => { stopLobbyMicRef.current = stop; }}
            />
          </div>
        ) : null}
        <Button type="button" fullWidth size="lg" disabled={startDisabled || !micReady} onClick={() => { stopLobbyMicRef.current(); onStart(lang); }} className="mb-3">{startLabel}</Button>
        {!bypassSchedule && slot.hasSlot && slot.tooLate ? null : (
          <Button type="button" variant="secondary" fullWidth size="lg" onClick={() => setShowSched(true)} className="mb-3">Maybe later</Button>
        )}
        <button type="button" onClick={onLogout} className="w-full py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded-control mb-2 inline-flex items-center justify-center gap-1.5">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
          Logout
        </button>
        <button type="button" onClick={onBack} className="text-ink-400 text-sm hover:text-ink-900">← Back</button>
        {showSched ? (
          <InterviewScheduleModal
            jobTitle={job?.title}
            busy={schedBusy}
            onConfirm={handleScheduleConfirm}
            onCancel={() => { if (!schedBusy) setShowSched(false); }}
          />
        ) : null}
      </div>
    </div>
  );
}
